
import { Component, Vue, Prop } from 'vue-property-decorator'
import ScriptLoader from '@/utils/ScriptLoader'
import { NavigationGuardNext, Route } from 'vue-router'
import { getIdLevel, getMigrated, getPartnerProxyId } from '@/utils/KeycloakUtils'
import i18n from '@/i18n'
import TeaserAccountTile from '@/components/tile/TeaserAccountTile.vue'
import TeaserPassword from '@/componentsTenant/images/TeaserPassword.vue'

@Component({
  i18n,
  components: {
    TeaserAccountTile,
    TeaserPassword
  },
  beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext) {
    Promise.all([
      ScriptLoader.preloadScript(window.ENV_CONFIG.WEB_COMPONENTS.CLAIMS).catch((_reason) => Promise.resolve()),
      ScriptLoader.preloadScript(window.ENV_CONFIG.WEB_COMPONENTS.CLAIMS_EMBEDDED).catch((_reason) => Promise.resolve())
    ])
      .then(() => next())
      .catch((_reason) => next())
  },
  beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
    Promise.all([
      ScriptLoader.unloadScript(window.ENV_CONFIG.WEB_COMPONENTS.CLAIMS).catch((_reason) => Promise.resolve()),
      ScriptLoader.unloadScript(window.ENV_CONFIG.WEB_COMPONENTS.CLAIMS_EMBEDDED).catch((_reason) => Promise.resolve())
    ])
      .then(() => next())
      .catch((_reason) => next())
  }
})
export default class ClaimsPage extends Vue {
  @Prop({ default: window.ENV_CONFIG.SERVICE_LINKS.SETTINGS_PAGE.CHANGE_SERVICECODEINPUT_PAGE })
  private enterServiceCodeUrl!: string

  @Prop({ default: window.ENV_CONFIG.SERVICE_LINKS.SETTINGS_PAGE.CHANGE_SERVICECODEREQUEST_PAGE })
  private misPlacedServiceCodeUrl!: string

  private partnerProxyId: string | null = null
  private migrated: string | null = null
  private idLevel: number | null = null

  public created(): void {
    this.partnerProxyId = getPartnerProxyId()
    this.idLevel = getIdLevel()
    this.migrated = getMigrated()
  }

  get showInfoBox(): boolean {
    if (this.migrated == null || this.idLevel == null) return true
    return this.idLevel == 0 && this.migrated == 'FALSE'
  }
}
